import { GET_ADDITIONAL_SERVICES_AND_TARIFF } from './actionTypes';

import addServicesRemote from '../../api/addServicesRemote';

import AddServicesTariff from '../../models/AddServicesTariff';
import ApiResponse from '../../models/ApiResponse';
import ResponseError from '../../models/ResponseError';

import { receiveError } from './notificationAction';

function addServiceTariffSuccess(serviceTariff: AddServicesTariff) {

  return {
    type: GET_ADDITIONAL_SERVICES_AND_TARIFF,
    data: serviceTariff
  };
}

function receiveServicesAndTariff(awbCode: string, awbNumber: string, version: number, isExport?: boolean, poNumber?: string) {

  return (dispatch: any) => {

    addServicesRemote.getServicesAndTariff(awbCode, awbNumber, version, isExport, poNumber).then((res: ApiResponse<AddServicesTariff>) => {

      const additionalServicesTariff: AddServicesTariff | undefined = res.result;
      const error: ResponseError | undefined = res.error;

      if (additionalServicesTariff) {
        dispatch(addServiceTariffSuccess(additionalServicesTariff));
      } 
  
      if (error) {
        dispatch(receiveError(error));
      }
    });
  };
}

export {
  receiveServicesAndTariff
};